import * as React from 'react';
import { Avatar as DSAvatar } from '@ghq-abi/design-system-v2';

type AvatarProps = {
  globalId?: string;
  name?: string;
  className?: string;
};

// Color palette for avatar backgrounds (consistent with DS theme)
const AVATAR_COLORS = [
  'bg-teal-500',
  'bg-blue-500',
  'bg-purple-500',
  'bg-orange-500',
  'bg-pink-500',
  'bg-cyan-500',
  'bg-indigo-500',
  'bg-green-500',
  'bg-amber-500',
  'bg-rose-500'
];

function getInitials(name?: string): string {
  if (!name) {
    return '';
  }
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

function getColorFromName(name?: string): string {
  if (!name) {
    return 'bg-gray-200';
  }
  // Simple hash function to get consistent color per name
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
}

export function Avatar({ name, className }: AvatarProps) {
  const initials = getInitials(name);
  const bgColor = getColorFromName(name);
  const textColor = name ? 'text-white' : 'text-gray-400';

  return (
    <DSAvatar.Root className={className}>
      <DSAvatar.Fallback className={`${bgColor} ${textColor}`}>
        {initials}
      </DSAvatar.Fallback>
    </DSAvatar.Root>
  );
}
